import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import { useGrade } from '../../../context/GradeContext';
import { useTCData } from '../../../context/TCContext';
import config from '../../../config';
import Swal from 'sweetalert2';
import { Modal, Button, Spinner } from 'react-bootstrap';
import axios from '../../../interceptor/axios-config';
import PrintModal from './PrintModal';

const initalUdata = {
    tc_id:'', student_name:'', pen:'', father_name:'', mother_name:'', date_of_birth:'', 
    class_last_studied:'', promotion_status:'', conduct:'', remarks:'', reason_for_leaving:''
  };

const Transfer = () => {

    // End-point for TC-Verification 
    const VERIFY_TC =`${config.apiBaseUrl}/tc/verifyTC.php`;

    //TC print modal
    const [showPrintModal, setShowPrintModal] = useState(false);

    //Verify Modal
    const [showVerifyModal, setShowVerifyModal] = useState(false);
    const [verifiedModal, setVerifiedModal] = useState(false);
    const [infoModal, setInfoModal] = useState(false);

    //Loading Info --> for spinner
    const [loadingInfo, setLoadingInfo] = useState(false);

    //serial no
    let slno = 1;
    
    // from contexts 
    const { grade } = useGrade();

    //List of verification Transfer Certificates
    const { tcData, loading, fetchTCs } = useTCData();

    //TC Id for printing
    const [tcPrintData, setTcPrintData ] = useState({});

    //final verified TC Data
    const [tcvData, setTcvData] = useState(initalUdata);

    // All useState hooks 
    const [selectedGrade, setSelectedGrade] = useState('--Select--');

    // Search 
    const [searchTerm, setSearchTerm] = useState('');

    const handleOpenPrintModal = (tc_id) => {
        if(tcData.length > 0){
            const fData = tcData.filter(item => item.tc_id === tc_id);
            setTcPrintData(fData[0]);
        }else{
            setTcPrintData({});
        }
        setShowPrintModal(true);
    };

    const handleClosePrintModal = () => {
        setShowPrintModal(false);
    };

    const handleRefresh = () => {
        fetchTCs();
    }
    const handleSelectOption = (e) => {
        setSelectedGrade(e.target.value);
    }
    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };

    // const filteredData = tcData.filter(item => {
    //     const searchTermLower = searchTerm.toLowerCase();
    //     return (
    //       (!selectedGrade || item.date_of_issue === selectedGrade) &&
    //       (
    //         item.student_name.toLowerCase().includes(searchTermLower) ||
    //         item.student_uid.toString().includes(searchTermLower) 
    //       )
    //     );
    //   });
    
    //Verify TC Function
    const verifyTCFunction = async () => {
        console.log(tcvData);
        setLoadingInfo(true);
        setVerifiedModal(true);
        try {
            const verification_response = await axios.patch(VERIFY_TC, tcvData);
            if (verification_response.data.message === 'TC Verification Successful') {
                setTimeout(() => {
                    setLoadingInfo(false);
                    setVerifiedModal(false);
                    Swal.fire({
                        title: 'TC verification',
                        text: 'Transfer certificate has been successfully verified.',
                        icon: 'success',
                        confirmButtonText: 'OK'
                    });
                }, 5000); // 5 seconds timeout
                fetchTCs();
                setShowVerifyModal(false);
            } else {
                console.log(verification_response.data);
                setLoadingInfo(false);
                setVerifiedModal(false);
            }
        } catch (error) {
            console.error('PATCH request error:', error);
            setLoadingInfo(false);
            setVerifiedModal(false);
        }
    };

    const reason_for_leaving = [
        "Family Relocation",
        "Admission to Another School",
        "Financial Reasons",
        "Health Issues",
        "Completion of Course"
    ];

    const handleTCDataChange = (e) => {
        const { name, value } = e.target; 
        setTcvData({ ...tcvData, [name]: value });
    };
    

    const getIDtoVerify = (tc_id) => {
        if (!tcData || tcData.length === 0) {
            console.error("tcData is empty or undefined");
            return; // Exit if tcData is empty
        }
        
        const selectedTC = tcData.filter(tc => tc.tc_id === tc_id);
        
        if (selectedTC.length > 0) {
            setTcvData(selectedTC[0]);
            setShowVerifyModal(true);
        } else {
            console.error("No matching Transfer Certificate found for the given ID");
        }
    }
    
    
    // let jstring = JSON.stringify(tcvData);
    console.log(tcData);
    // console.log(jstring);
   

    return (
        <>
            <div className="row">
                <div className="col-xl-12">                    
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="page-title flex-wrap">
                                <div className="input-group search-area mb-md-0 mb-3">
                                    <input type="text" className="form-control" placeholder="Search here..." onChange={handleChange}/>
                                    <span className="input-group-text">
                                        <Link to={"#"}>
                                            <svg wstudent_idth="15" height="15" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M17.5605 15.4395L13.7527 11.6317C14.5395 10.446 15 9.02625 15 7.5C15 3.3645 11.6355 0 7.5 0C3.3645 0 0 3.3645 0 7.5C0 11.6355 3.3645 15 7.5 15C9.02625 15 10.446 14.5395 11.6317 13.7527L15.4395 17.5605C16.0245 18.1462 16.9755 18.1462 17.5605 17.5605C18.1462 16.9747 18.1462 16.0252 17.5605 15.4395V15.4395ZM2.25 7.5C2.25 4.605 4.605 2.25 7.5 2.25C10.395 2.25 12.75 4.605 12.75 7.5C12.75 10.395 10.395 12.75 7.5 12.75C4.605 12.75 2.25 10.395 2.25 7.5V7.5Z" fill="#01A3FF"/>
                                            </svg>
                                        </Link>
                                    </span>
                                </div>
                                <div className='d-flex'>
                                    <Form.Select size="sm" style={{width:'120px'}} value={selectedGrade} onChange={handleSelectOption}>
                                        {grade.map((item, index) => 
                                            <option value={item.class_promotion_status} key={index}>{item.class_label}</option>
                                        )}
                                    </Form.Select>
                                    <span className='p-2'></span>
                                    <button className='btn btn-success' onClick={handleRefresh} disabled={loading}>
                                        Refresh Data
                                    </button>
                                </div>
                            </div>
                        </div>         
                        <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                            <div className="table-responsive full-data pb-20">
                                <div student_id="example-student_wrapper" className="dataTables_wrapper no-footer">  
                                    <table className="table-responsive-lg table display dataTablesCard student-tab dataTable no-footer" id="example-student">
                                        <thead>
                                            <tr>
                                                <th>Sr. No.</th>
                                                <th>Name</th>
                                                <th>Grade/ TC Number</th>
                                                <th>UID</th>
                                                <th>PEN</th>
                                                <th>Issued On</th>
                                                <th>Status</th>
                                                <th>Take Action</th>
                                            </tr>
                                        </thead>
                                        {tcData.length > 0 
                                            ?(
                                                <tbody>
                                                    {tcData.map((item, ind)=>(                                
                                                        <tr key={ind}>
                                                            <td>{slno ++}</td>
                                                            <td>
                                                                <div className="trans-list">
                                                                    <h4>{item.student_name}</h4>
                                                                </div>
                                                            </td>
                                                            <td><span className="text-primary font-w600">Class-{item.class_last_studied}/ {item.tc_number}</span></td>
                                                            
                                                            <td><h6 className="mb-0">{item.student_uid}</h6></td>
                                                            <td><h6 className="mb-0">{item.pen}</h6></td>
                                                            <td>
                                                                <div className={`badge bg-${item.date_of_issue === 'VII A' ? 'secondary' : item.date_of_issue === 'XII A' ? 'primary' : 'warning'}`}>
                                                                    {item.date_of_issue}
                                                                </div>
                                                            </td>
                                                            <td>
                                                            <div className="d-flex">
                                                                {item.tc_status === 'in process' && (
                                                                    <div className="icon-box icon-box-sm bg-light me-2">
                                                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M11 0C5.48 0 1 4.48 1 10s4.48 10 10 10 10-4.48 10-10S16.52 0 11 0zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-4h2v2h-2zm0-8h2v6h-2z" fill="var(--danger)"/>
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                                {item.tc_status === 'ready' && (
                                                                    <div className="icon-box icon-box-sm bg-light me-2">
                                                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M9 16C4.03 16 0 11.97 0 7S4.03 -2 9 -2s9 4.03 9 9-4.03 9-9 9zM7.293 11.293l6-6 1.414 1.414-6 6-3-3 1.414-1.414 1.586 1.586z" fill="var(--success)"/>
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                                {item.tc_status === 'printed' && (
                                                                    <div className="icon-box icon-box-sm bg-light me-2">
                                                                        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                            <path d="M19 4H3C1.9 4 1 4.9 1 6v6h4v4h12v-4h4V6c0-1.1-.9-2-2-2zm-2 10H5v-6h12v6zm2-10h-4V1H7v3H3c-1.1 0-2 .9-2 2v4h2V6h16v4h2V6c0-1.1-.9-2-2-2z" fill="var(--primary)"/>
                                                                        </svg>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            </td>                                                           
                                                            <td>
                                                            <div className="d-flex">
                                                                {item.verification === 'pending'
                                                                    ?(<div className="icon-box icon-box-sm bg-danger me-2">
                                                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>getIDtoVerify(item.tc_id)}>
                                                                            <path d="M11 0L2 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V4l-9-4zm0 19.74c-4.03-1.05-7-5.16-7-9.74V5.3l7-3.11 7 3.11v4.7c0 4.58-2.97 8.69-7 9.74z" fill="var(--primary)"/>
                                                                            <path d="M10 14l-3.5-3.5L8.12 9.38 10 11.26l5.88-5.88 1.41 1.41L10 14z" fill="var(--primary)"/>
                                                                        </svg>
                                                                    </div>)
                                                                    :(<div className="icon-box icon-box-sm bg-success me-2">
                                                                        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={()=>setInfoModal(true)}>
                                                                            <path d="M11 0L2 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V4l-9-4zm0 19.74c-4.03-1.05-7-5.16-7-9.74V5.3l7-3.11 7 3.11v4.7c0 4.58-2.97 8.69-7 9.74z" fill="var(--primary)"/>
                                                                            <path d="M10 14l-3.5-3.5L8.12 9.38 10 11.26l5.88-5.88 1.41 1.41L10 14z" fill="var(--primary)"/>
                                                                        </svg>
                                                                    </div>)
                                                                }
                                                                <div className="icon-box icon-box-sm bg-light">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24" >
                                                                    <path d="M600-240v-80h160v80H600Zm0-320v-80h280v80H600Zm0 160v-80h240v80H600ZM120-640H80v-80h160v-60h160v60h160v80h-40v360q0 33-23.5 56.5T440-200H200q-33 0-56.5-23.5T120-280v-360Zm80 0v360h240v-360H200Zm0 0v360-360Z"/></svg>
                                                                </div>
                                                                <div className="icon-box icon-box-sm bg-light">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" onClick={()=>handleOpenPrintModal(item.tc_id)}>
                                                                        <path d="M19 8H5c-1.1 0-2 .9-2 2v7h4v4h10v-4h4v-7c0-1.1-.9-2-2-2zm-4 11H9v-6h6v6zm3-9H6V7h12v3zm-2-7H8V2h8v2z"/>
                                                                    </svg> 
                                                                </div>
                                                            </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            )
                                            :'No data yet'
                                        }                                        
                                    </table> 
                                </div>
                            </div>  
                        </div> 
                    </div>    
                </div>    
            </div>  

            {/* Spinner model for TC Verification  */}
            <Modal show={verifiedModal} onHide={() => setVerifiedModal(false)}>
                <Modal.Header closeButton>
                <Modal.Title>Verifying TC</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                {loadingInfo ? (
                    <div className="text-center">
                    <Spinner animation="border" role="status">
                        <span className="sr-only">Loading...</span>
                    </Spinner>
                    <p>Please wait.... While TC is being verified</p>
                    </div>
                ) : (
                    <p>TC Verification Complete.</p>
                )}
                </Modal.Body>
            </Modal>  

            {/*info modal  */}
            <Modal show={infoModal} onHide={() => setInfoModal(false)}>
                <Modal.Header closeButton>
                <Modal.Title>Verification complete</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h3>TC already verified</h3>
                </Modal.Body>
            </Modal>

            {/* Verification modal  */}
            <Modal  show={showVerifyModal} size="xl" onHide={() => setShowVerifyModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Transfer certificate Data Verification Form</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {tcvData
                    ?(
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-xl-6 col-sm-6">
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Full Name<span className="required">*</span></label>
                                            <input                                                    
                                               type="text" 
                                               className="form-control" 
                                               id="exampleFormControlInput3" 
                                               name="student_name"
                                               value={tcvData.student_name}
                                               onChange={handleTCDataChange}
                                               required
                                            />
                                        </div>                                         
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Class last attended<span className="required">*</span></label>
                                            <input                                                    
                                                type="text" 
                                                className="form-control" 
                                                id="exampleFormControlInput5"
                                                name="class_last_studied" 
                                                value={tcvData.class_last_studied}
                                                onChange={handleTCDataChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Father's Full Name<span className="required">*</span></label>
                                            <input                                                    
                                                type="text" 
                                                className="form-control" 
                                                id="exampleFormControlInput5" 
                                                name="father_name"
                                                value={tcvData.father_name}
                                                onChange={handleTCDataChange}
                                                required
                                            />
                                        </div>.
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Conduct<span className="required">*</span></label>
                                            <select 
                                                className="form-control" 
                                                id="exampleFormControlInput4" 
                                                name="conduct" 
                                                value={tcvData.conduct} 
                                                onChange={handleTCDataChange}
                                            >
                                                <option value="">---Select Option---</option>
                                                <option value="Excellent">Excellent</option>
                                                <option value="Good">Good</option>
                                                <option value="Average">Average</option>
                                                <option value="Satisfactory">Satisfactory</option>
                                                <option value="Poor">Poor</option>
                                            </select>
                                        </div>
                                        <div className="d-flex mb-3">
                                            <div>
                                                <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Remarks<span className="required">*</span></label>
                                                <textarea                                                    
                                                    type="text" 
                                                    className="form-control" 
                                                    name="remarks"
                                                    rows="2"
                                                    id="exampleFormControlInput5" 
                                                    value={tcvData.remarks}
                                                    onChange={handleTCDataChange}
                                                    required
                                                />
                                            </div>
                                            <span className='p-2'></span>
                                            <div>
                                                <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Promotion Status<span className="required">*</span></label>
                                                    <form className="d-flex flex-column align-items-start">
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="promotion_status" id="promotion_status" value='Promoted'  checked={tcvData.promotion_status === 'Promoted'} onChange={handleTCDataChange} />
                                                            <label className="form-check-label" htmlFor="promotion_status">
                                                                Promoted
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input className="form-check-input" type="radio" name="promotion_status" id="promotion_status" value='Not Promoted' checked={tcvData.promotion_status === 'Not Promoted'} onChange={handleTCDataChange} />
                                                            <label className="form-check-label" htmlFor="promotion_status">
                                                                Detained
                                                            </label>
                                                        </div>
                                                    </form>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-xl-6 col-sm-6">
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Date Of Birth<span className="required">*</span></label>
                                            <input                                                    
                                                type="text" 
                                                className="form-control" 
                                                id="exampleFormControlInput5" 
                                                placeholder='YYYY-MM-DD'
                                                name="date_of_birth"
                                                value={tcvData.date_of_birth}
                                                onChange={handleTCDataChange}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Permanent Education Number (PEN)<span className="required">*</span></label>
                                            <input                                                    
                                                type="text" 
                                                className="form-control" 
                                                id="exampleFormControlInput5" 
                                                name="pen"
                                                value={tcvData.pen}
                                                onChange={handleTCDataChange}
                                                required
                                            />
                                        </div> 
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary">Mother's Full Name<span className="required">*</span></label>
                                            <input                                                    
                                                type="text" 
                                                className="form-control" 
                                                id="exampleFormControlInput5" 
                                                name="mother_name"
                                                value={tcvData.mother_name}
                                                onChange={handleTCDataChange}
                                                required
                                            />
                                        </div>  
                                        <div className="mb-3">
                                            <label htmlFor="exampleFormControlInput5" className="form-label text-primary mt-3">
                                                Reason for Leaving<span className="required">*</span>
                                            </label>
                                            <div style={{ marginTop: '0.5rem', border: '1px solid #ddd', borderRadius: '8px', padding: '0.5rem' }}>
                                                {reason_for_leaving.map((reason, index) => (
                                                    <div key={index} className="form-check">
                                                        <input 
                                                            className="form-check-input" 
                                                            type="radio" 
                                                            name="reason_for_leaving" 
                                                            id={`reason${index}`} 
                                                            value={reason} 
                                                            checked={tcvData.reason_for_leaving === reason}
                                                            onChange={(e) => handleTCDataChange(e, reason)}
                                                        />
                                                        <label className="form-check-label" htmlFor={`reason${index}`}>
                                                            {reason}
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>

                                    </div>                               
                                </div>
                            </div>
                        </div>
                    </div>)
                    :''
                }

                </Modal.Body> 
                <div className="modal-footer">
                    <button type="button" className="btn btn-success light" onClick={verifyTCFunction} >Confirm</button>
                    <button type="button" className="btn btn-danger light" onClick={() => setShowVerifyModal(false)} >Close</button>
                </div>            
            </Modal> 
            {/* call tc print modal   */}
            <PrintModal show={showPrintModal} onClose={handleClosePrintModal} tcPrintData={tcPrintData} />
        </>
    )
}

export default Transfer
